import React from 'react';
import { Image } from '@unpic/react';
import { getAssetId } from './helpers/ProductGalleryHelper';

interface DefaultVideoImageProps {
  video?: string;
}

const DefaultVideoImage = ({ video }: DefaultVideoImageProps) => {
  if (!video) return null;
  const videoId = getAssetId(video);
  return (
    <Image
      src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
      alt={`video-${videoId}`}
      layout="fullWidth"
      breakpoints={[150, 260, 450, 740]}
      className="pd-cover-parent"
    />
  );
};

export default DefaultVideoImage;
